import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of, switchMap, take, tap } from 'rxjs';
import { pagesPATH } from '../models_new/config/pages';
import { DialogSize } from '../models_new/enums/dialogSize';
import { LocalStorageKey } from '../models_new/enums/local-storage-keys';
import { DialogService } from '../services/dialog.service';
import {
  LocalStorageService,
  StorageMethod,
} from '../services/local-storage.service';
import { EulaDialogComponent } from './eula-dialog';

@Injectable({
  providedIn: 'root',
})
export class EulaGuard {
  constructor(
    private ls: LocalStorageService,
    private dialog: DialogService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isPublic =
      state.url.includes('o=1') || state.url.includes('public=true');

    // Not public, skip
    if (!isPublic) {
      return of(true);
    }

    const stored = this.ls.getData(LocalStorageKey.EULA);
    if (stored?.accepted) {
      return of(true);
    } else {
      return this.dialog
        .showStandardDialog({
          content: {
            title: 'MyRobot.Cloud’s EULA',
            component: EulaDialogComponent,
          },
          button: { text: 'I Accept', enableCancel: true },
          gui: { size: DialogSize.MEDIUM },
        })
        .afterClosed()
        .pipe(
          take(1),
          switchMap((res: boolean) => {
            const accepted = res ? true : false;
            this.ls.setData(
              LocalStorageKey.EULA,
              { accepted: accepted },
              StorageMethod.LOCAL
            );
            return accepted ? of(true) : of(false);
          }),
          tap((accepted: boolean) => {
            if (!accepted) {
              this.router.navigate([pagesPATH.LANDING_PAGE]);
            }
          })
        );
    }
  }
}
